/* istanbul ignore next */
export default ((typeof window !== 'undefined' ? window : global) || {});
//# sourceMappingURL=global.js.map